import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/pro-light-svg-icons'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
  Tools,
} from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useAgency, { useAgencyForm } from '@hooks/useAgency'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import ApiKeys from '@components/ApiKeys'

import Accounting from '../Accounting'
import AgencyPortals from '../AgencyPortals'
import CRMSync from '../CRMSync'
import Domain from '../Domain'
import IntegrationPlatforms from '../IntegrationPlatforms'
import Portals from '../Portals'

import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  agencyId: number,
}

const PageContent = (props: PageContentProps) => {
  const { agencyId } = props

  const agencyPayload = useAgency({ id: agencyId })
  const {
    agency,
    callbacks: {
      manageAgencyIntegrationPermissions,
      updateAgency: updateFn,
    },
    loading,
    updating,
  } = agencyPayload

  const agencyFormPayload = useAgencyForm(agency)
  const { entityState, saveEnabled } = agencyFormPayload

  const updateAgencyPayload: HandleCallbackActionParams = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Agency Updated',
  }

  return (
    <PageLayout entityPayload={agencyPayload} activeTabBarItemKey="integrations">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && <NotificationBannerLocation locationKey="agency.integrations.banner" /> }

        {!loading && <Accounting agencyFormPayload={agencyFormPayload} />}

        {!loading && (
          <ApiKeys
            hideFilters
            filters={{ owner_id: agencyId, owner_type: 'Agency' }}
            userSearchRequestOptions={{ agency_id: agencyId }}
          />
        )}

        {!loading && <CRMSync agencyPayload={agencyPayload} />}

        {!loading && <AgencyPortals selectedAgencyId={agencyId} />}

        <Portals selectedAgencyId={agencyId} />

        {!loading && <Domain />}

        {/*
         // @ts-expect-error TS2322 */}
        {!loading && <IntegrationPlatforms agency={agency} />}

        <SaveFormModule>
          <Button
            buttonStyle="primaryCreate"
            disabled={!saveEnabled}
            loading={updating}
            marginLeft="auto"
            onClick={() => handleCallbackAction(updateAgencyPayload)}
            size="medium"
          >
            Save Details
          </Button>
        </SaveFormModule>
      </Columns.Main>

      <Columns.Sidebar>

        <Tools>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faCog} />}
            marginBottom="medium"
            onClick={() => manageAgencyIntegrationPermissions()}
            size="medium"
          >
            Integration Settings
          </Button>
        </Tools>
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
